/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClientApi, ClientApiConfig } from '@eta/components';
import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface INationalIdRegistryPublicClient {
    /**
     * @return Success
     */
    getUserByNatID(nid: string | null): Promise<UserDetailsDto>;
}

export class NationalIdRegistryPublicClient extends BaseClientApi implements INationalIdRegistryPublicClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: ClientApiConfig, baseUrl?: string, instance?: AxiosInstance) {
        super(configuration);
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");
    }

    /**
     * @return Success
     */
    getUserByNatID(nid: string | null , cancelToken?: CancelToken | undefined): Promise<UserDetailsDto> {
        let url_ = this.baseUrl + "/api/v{version}/person/{nid}";
        if (nid === undefined || nid === null)
            throw new Error("The parameter 'nid' must be defined.");
        url_ = url_.replace("{nid}", encodeURIComponent("" + nid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserByNatID(_response);
        });
    }

    protected processGetUserByNatID(response: AxiosResponse): Promise<UserDetailsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDetailsDto.fromJS(resultData200);
            return result200;
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDetailsDto>(<any>null);
    }
}

export enum ResponseStatus {
    None = "None",
    Valid = "Valid",
    Suspended = "Suspended",
    Expired = "Expired",
    NotFound = "NotFound",
    DeadPerson = "DeadPerson",
}

export class UserDetailsDto implements IUserDetailsDto {
    ggEnable!: boolean;
    ggofFline!: boolean;
    nid!: string | undefined;
    firstName!: string | undefined;
    otherNames!: string | undefined;
    status!: ResponseStatus;

    constructor(data?: IUserDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ggEnable = _data["ggEnable"];
            this.ggofFline = _data["ggofFline"];
            this.nid = _data["nid"];
            this.firstName = _data["firstName"];
            this.otherNames = _data["otherNames"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ggEnable"] = this.ggEnable;
        data["ggofFline"] = this.ggofFline;
        data["nid"] = this.nid;
        data["firstName"] = this.firstName;
        data["otherNames"] = this.otherNames;
        data["status"] = this.status;
        return data; 
    }

    clone(): UserDetailsDto {
        const json = this.toJSON();
        let result = new UserDetailsDto();
        result.init(json);
        return result;
    }
}

export interface IUserDetailsDto {
    ggEnable: boolean;
    ggofFline: boolean;
    nid: string | undefined;
    firstName: string | undefined;
    otherNames: string | undefined;
    status: ResponseStatus;
}

export class ApiException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}